import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import './InfoBox.scss';
import CheckImage from './Check.svg';
import CheckImageGray from './CheckGray.svg';

const InfoBox = props => (
  <div className={props.infoBoxClass}>
    {props.children}
    <div className="info-box-title">{props.title}</div>
    <ul className="info-box-list">
      {map(props.listItems, (item, index) =>
         item.props.children ?
          (
            <li key={index}>
              <img
                src={CheckImage}
                className="check check-orange"
                height="10"
                alt="Check"
                role="presentation"
              />
              <img
                src={CheckImageGray}
                className="check check-gray"
                height="10"
                alt="Check"
                role="presentation"
              /> {item}
            </li>
          )
          : null
      )}
    </ul>
  </div>
);

InfoBox.propTypes = {
  infoBoxClass: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  listItems: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node
};

export default InfoBox;



/** WEBPACK FOOTER **
 ** ./src/components/InfoBox/InfoBox.js
 **/